/**
 * Time Off Request Type Codes
 */
export enum TimeOffRequestType {
  V = 'Vacation',
  F = 'Float Day',
  D = 'Flexible Personal Day',
  B = 'Birthday',
  A = 'Vacation Bid',
  O = 'Other',
  M = 'Multiple',
}

/**
 * Time Off Duration Types
 */
export enum TimeOffDuration {
  F = 'Full Day',
  P = 'Partial Day',
}

/**
 * All valid time off request type codes (for API filters)
 */
export const ALL_TIME_OFF_TYPE_CODES: (keyof typeof TimeOffRequestType)[] = ['V', 'F', 'D', 'B', 'A', 'O']

/**
 * Alternate labels mapping for filter UI compatibility
 */
export const TIME_OFF_TYPE_ALTERNATE_LABELS: Record<string, keyof typeof TimeOffRequestType> = {
  'FLOAT': 'F',
  'FPD': 'D',
  'OTHER': 'O',
}
